import React from 'react';
import { useApp } from '../contexts/AppContext';

const AppConfigDisplay = () => {
  const {
    appConfig,
    getAppName,
    getPrimaryColor,
    getSecondaryColor,
    hasFeature,
    getNavItems
  } = useApp();

  // Function to check if build-time config is being used
  const isBuildTimeConfig = () => {
    try {
      return typeof window.__APP_NAME__ !== 'undefined';
    } catch (e) {
      return false;
    }
  };

  // Helper to convert object to formatted string
  const formatObject = (obj) => {
    return JSON.stringify(obj, null, 2);
  };

  // Create an array of feature flags to display
  const featureFlags = [
    'adminPanel',
    'userManagement',
    'appManagement',
    'courses',
    'lessons',
    'bibleApi',
    'community',
    'navbar',
    'footer',
    'testFeature'
  ];

  return (
    <div style={{ 
      padding: '20px', 
      border: '1px solid #ccc', 
      borderRadius: '5px',
      margin: '20px',
      backgroundColor: '#f9f9f9'
    }}>
      <h2 style={{ color: getPrimaryColor() }}>
        App Configuration: {getAppName()}
      </h2>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Basic Info</h3>
        <ul>
          <li><strong>App Name:</strong> {getAppName()}</li>
          <li><strong>Primary Color:</strong> 
            <span 
              style={{ 
                display: 'inline-block', 
                width: '20px', 
                height: '20px', 
                backgroundColor: getPrimaryColor(),
                marginLeft: '10px',
                verticalAlign: 'middle'
              }}
            ></span> {getPrimaryColor()}
          </li>
          <li><strong>Secondary Color:</strong> 
            <span 
              style={{ 
                display: 'inline-block', 
                width: '20px', 
                height: '20px', 
                backgroundColor: getSecondaryColor(),
                marginLeft: '10px',
                verticalAlign: 'middle'
              }}
            ></span> {getSecondaryColor()}
          </li>
          <li><strong>Configuration Source:</strong> {isBuildTimeConfig() ? 'Build-time' : 'Runtime'}</li>
        </ul>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Navigation</h3>
        <ul>
          {getNavItems().map((item, index) => (
            <li key={index}>
              {item.label} → {item.path}
            </li>
          ))}
        </ul>
      </div>
      
      <div style={{ marginBottom: '20px' }}>
        <h3>Feature Flags</h3>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Feature</th>
              <th style={{ textAlign: 'left', padding: '8px', borderBottom: '1px solid #ddd' }}>Enabled</th>
            </tr>
          </thead>
          <tbody>
            {featureFlags.map((feature, index) => (
              <tr key={index}>
                <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>{feature}</td>
                <td style={{ padding: '8px', borderBottom: '1px solid #eee' }}>
                  {hasFeature(feature) ? '✅' : '❌'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div>
        <h3>Raw Configuration</h3>
        <pre style={{ 
          backgroundColor: '#eee', 
          padding: '10px', 
          borderRadius: '5px',
          overflow: 'auto',
          maxHeight: '300px'
        }}>
          {formatObject(appConfig)}
        </pre>
      </div>
    </div>
  );
};

export default AppConfigDisplay; 